import Script from "next/script";
import React from "react";
import { useOdooLiveChatLoader } from "hooks/use-odoo-live-chat-loader/use-odoo-live-chat-loader";

// PoC: embeds Odoo 18 Live Chat. See useOdooLiveChatLoader for when the Odoo
// scripts are allowed to load.
export const OdooLiveChat: React.FC = () => {
  const { isEnabled, isLoaderReady, loaderSrc, assetsSrc, onLoaderLoad } =
    useOdooLiveChatLoader();

  if (!isEnabled) return null;

  return (
    <>
      <Script
        id="odoo-livechat-loader"
        strategy="afterInteractive"
        src={loaderSrc}
        onLoad={onLoaderLoad}
      />
      {isLoaderReady && (
        <Script
          id="odoo-livechat-assets"
          strategy="afterInteractive"
          src={assetsSrc}
        />
      )}
    </>
  );
};
